<template>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Nama Pelanggan</th>
        <th scope="col">NO. Telepon</th>
        <th scope="col">Total Topup</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in items"
        :key="item.uuid"
      >
        <td class="text-capitalize">{{ item.subject.name }}</td>
        <td>{{ item.subject.phone_number }}</td>
        <td>{{ formatToRupiah(item.amount) }}</td>
      </tr>
    </tbody>
    <tbody v-if="items.length === 0">
      <tr>
        <td
          colspan="4"
          class="text-center"
        >
          Data kosong.
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'TopupDeposit',
  props: ['items'],
  data() {
    return {
      histories: [
        {
          created_at: '2025-04-15 17:24:01',
          amount: '50000.00',
          subject: {
            formatted_id: '#10430',
            uuid: '815680ed-63eb-4e5e-ad18-40a846964185',
            customer_type: 'Toko',
            email: null,
            name: 'test deposit',
            alias_name: null,
            phone_number: '6285637373737',
          },
        },
      ],
    };
  },
  methods: {
    formatToRupiah(amount) {
      const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      });
      return formatter.format(amount);
    },
  },
};
</script>
